<template>
  <div
    :class="isLoading || !campaignData ? 'campaign-banner__container--loading' : 'campaign-banner__container'"
  >
    <div>
      <z-link
        v-if="banner"
        :href="banner.url"
        :aria-label="banner.alt"
      >
        <VLazyImage
          :src="banner.src['desktop@1x']"
          :alt="banner.alt"
          use-picture
        >
          <source
            media="(min-width: 768px)"
            :srcset="`${banner.src['desktop@1x']}, ${banner.src['desktop@2x']} 2x`"
          >
          <source
            media="(max-width: 767px)"
            :srcset="`${banner.src['mobile@1x']}, ${banner.src['mobile@2x']} 2x`"
          >
        </VLazyImage>
      </z-link>
    </div>
  </div>
</template>

<script>
import VLazyImage from 'v-lazy-image/v2'
import { CampaignConfig } from '~/assets/js/services/campaign-config'

export default {
  name: 'CampaignBanner',
  components: {
    VLazyImage,
  },
  props: {
    campaignData: {
      type: Array,
      default: () => null,
    },
    isLoading: {
      type: Boolean,
      default: true,
    },
    context: {
      type: String,
      default: 'action',
    },
    size: {
      type: String,
      default: 'large',
    },
  },
  computed: {
    banner () {
      const config = new CampaignConfig(this.campaignData, this.$imageboss)
      const campaign = config.getCampaignFor('Graduação')
      return config.getBannerForCampaing(campaign, this.context, this.size)
    },
  },
}
</script>

<style lang="scss" scoped>
.campaign-banner__container {
  align-items: center;
  display: flex;
  flex-direction: row;
  height: 88px;
  justify-content: center;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
  @media (min-width: $breakpoint-desktop){
    height: 131px;
  }
}

.campaign-banner__image {
  object-fit: cover;
}

.campaign-banner__container--loading{
  animation: loading 1.5s infinite;
  background:
    linear-gradient(0.25turn, transparent, rgb(197, 197, 197), transparent),
    linear-gradient(#eee, #eee);
  cursor: progress;
  display: block;
  height: 88px;
  width: 100%;
  @media (min-width: $breakpoint-desktop){
    height: 131px;
  }
}
@keyframes loading {
  to {
    background-position: 315px 0, 0 0, 0 190px, 50px 195px;
  }
}

</style>
